import React from "react";
import styled from "styled-components";
import { media } from "styled-bootstrap-grid";

const Wrapper = styled.div`
  margin: 0 auto;
	padding: 0 2rem;
  width: 100%;
  ${media.md`
		width: ${props => props.theme.container.md}px;
  `}
  ${media.lg`
		width: ${props => props.theme.container.lg}px;
  `}
	${media.xl`
		width: ${props => props.theme.container.xl}px;
  `}
	${media.xxl`
		width: ${props => props.theme.container.xxl}px;
  `}
`;

const Container = React.forwardRef(({ className, children }, ref) => {
  return <Wrapper className={className} ref={ref}>{children}</Wrapper>;
});

export default Container;
